// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"96b194e5","160":"7e19fe05","243":"83bd1940","379":"7f4703a3","452":"e5ca696e","532":"0bf84264"}[chunkId] + ".chunk.js";
};